import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type ShopOrder = {
  shop_order_id?: number; // 매장 메뉴 idx
  user_id?: number;
  shop_information_id?: number;
  forwarding_location_id?: number;
  product_information?: { [key: string]: Record<string, any> };
  final_discount?: number;
  final_reward_point?: number;
  final_price?: number;
  coupon_info?: { [key: string]: Record<string, any> };
  grade_reward_rate?: number;
  type?: string;
  payment_state?: string;
  payment_method?: string;
  payment_completion_date?: number;
  use_point?: number;
  use_jm_pay?: number;
  payment_info?: { [key: string]: Record<string, any> };
  payment_serial_number?: string;
  order_route?: string;
  delivery_address?: { [key: string]: Record<string, any> };
  final_delivery_price?: number;
  created_at?: number;
  updated_at?: number;
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ShopOrder
   * --
   */
  getShopOrders: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_SHOP_ORDER, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ShopOrder
   * --
   */
  getShopOrder: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_SHOP_ORDER, {
        shop_order_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ShopOrder
   * --
   */
  createShopOrder: async (body: ShopOrder) => {
    try {
      const res = await $http.post(APIConstant.CREATE_SHOP_ORDER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ShopOrder
   * --
   */
  updateShopOrder: async (body: ShopOrder) => {
    try {
      const { shop_order_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_SHOP_ORDER, {
        shop_order_id: shop_order_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ShopOrder
   * --
   */
  deleteShopOrder: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_SHOP_ORDER, {
        shop_order_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ShopOrder
   * --
   */
  createManualShopOrder: async (body: ShopOrder) => {
    try {
      const res = await $http.post(APIConstant.CREATE_MANUAL_SHOP_ORDER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
